import { Button, Table, TableBody, TableCell, TableFooter, TableHead, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";

import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";

import useProjectCostCreate from "../api/useProjectCostCreate";
import useProjectCostGetAllForProject from "../api/useProjectCostGetAllForProject";
import ProjectCostVisitTable from "../components/ProjectCostVisitTable";
import useRequireCurrentProject from "../hooks/useRequireCurrentProject";

export default function ProjectCostScreen() {
    const { t } = useTranslation("project");
    const [searchParams] = useSearchParams();
    const { project } = useRequireCurrentProject();
    const { data } = useProjectCostGetAllForProject(project, Object.fromEntries(searchParams));
    const { projectCostCreate } = useProjectCostCreate(project);

    return (
        <GaiaPageLayoutColumn maxWidth="xl">
            {data?.map(costCalc => (
                <GaiaPageComponent key={costCalc.id} title={costCalc.name}>
                    <Table sx={{ mb: 8 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Areas</TableCell>
                                <TableCell>Travel time</TableCell>
                                <TableCell>Travel cost</TableCell>
                                <TableCell>Work time</TableCell>
                                <TableCell>Total</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {costCalc.data.prices.map(priceEntry => (
                                <TableRow key={priceEntry.id}>
                                    <TableCell>{priceEntry.protocolName}</TableCell>
                                    <TableCell>{priceEntry.areaCount}</TableCell>
                                    <TableCell>{priceEntry.travelTime}</TableCell>
                                    <TableCell>{priceEntry.travelCost}</TableCell>
                                    <TableCell>{priceEntry.workTime}</TableCell>
                                    <TableCell>{priceEntry.total}</TableCell>
                                </TableRow>
                            ))}
                            <TableRow>
                                <TableCell colSpan={4} />
                                <TableCell variant="head">Subtotal (exl BTW)</TableCell>
                                <TableCell variant="head">{costCalc.data.subTotal}</TableCell>
                            </TableRow>
                        </TableBody>
                        <TableFooter></TableFooter>
                    </Table>

                    <ProjectCostVisitTable protocols={costCalc.data.protocols} />

                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={2}>Project settings</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>Travel cost</TableCell>
                                <TableCell>{costCalc.data.travelCost}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Travel distance</TableCell>
                                <TableCell>{costCalc.data.travelDistance}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Travel duration</TableCell>
                                <TableCell>{costCalc.data.travelDuration}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </GaiaPageComponent>
            ))}

            <Button onClick={() => projectCostCreate("Project cost")}>{t("projectCostScreen.create")}</Button>
        </GaiaPageLayoutColumn>
    );
}
